import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { displayToast } from 'bundles/connect/helpers/display_toast';
import { deleteSavedSearch } from 'bundles/connect/helpers/prospect_api';
import type { SavedSearch } from 'bundles/connect/types';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap-5';

type Props = {
  savedSearch: SavedSearch | null;
  onHide: () => void;
  onDelete: (id: number) => void;
}

export default function SavedSearchDeleteModal({ savedSearch, onHide, onDelete }: Props) {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = () => {
    if (!savedSearch) return;

    setDeleting(true);
    deleteSavedSearch(savedSearch.id).then(() => {
      onDelete(savedSearch.id);
      setDeleting(false);
      displayToast('Saved search deleted', 'success');
      onHide();
    });
  };

  return (
    <Modal centered show={!!savedSearch} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete the saved search <strong>{savedSearch?.name}</strong>?
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button disabled={deleting} variant="text-primary" onClick={onHide}>Cancel</Button>
        <Button disabled={deleting} variant="danger" onClick={handleDelete}>
          <FontAwesomeIcon className="me-2" icon={faTrash} />
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
